import React, { useEffect } from "react";
import { useGetFetchNew } from "../../../data/Queries";
import { coins_spent } from "../../../data/ApiEndpoints";
import Loader from "../../../components/ui/Loader";

import CoinCard from "./CoinSpentCard";

const CoinSpent = ({ userInfoData, gymId }) => {
  const {
    data: coinsSpentData,
    isLoading,
    refetch,
    isFetching,
  } = useGetFetchNew({
    token: userInfoData?.token,
    key: "coins_spent",
    url: `${coins_spent}`,
    filters: {
      gym_id: gymId || "",
    },
  });

  useEffect(() => {
    refetch();
  }, [gymId]);

  return (
    <div className="coin__Spent">
      <h4>Coins Spent</h4>
      {isLoading ? (
        <div>
          <Loader />
        </div>
      ) : (
        <div className="coinSpent__Cards">
          {coinsSpentData?.data?.map((item, index) => (
            <CoinCard
              key={index}
              {...item}
              userInfoData={userInfoData}
              gymId={gymId}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CoinSpent;
